import MobileShowcaseEventBanner from './mobile-showcase-event-banner'

export default MobileShowcaseEventBanner
